import {Component} from "preact";
import style from './styles.scss';
import Toolbar from "../../../../../layout/toolbar";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import ScrollableSection from "../../../../../layout/scrollable-section";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import SectionContainer from "../../../../../layout/section-container";
import ToolbarButton from "../../../../../common/toolbar-button";
import LogoutIcon from "mdi-preact/LogOutIcon";
import ConfigService from "../../../../../../services/ConfigService";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";
import BackdropCover from "../../../../../common/backdrop-cover";
import Spinner from "../../../../../common/spinner";
import Text from "../../../../../common/text";
import {execute} from "../../../../../../services/CallbackService";
import {createEvent} from "../../../../../../utilities/create-event";
import LetterIcon from "../../../../../common/letter-icon";
import AccountEditIcon from "mdi-preact/AccountEditIcon";
import LanguageFlagIcon from "../language-flag-icon";
import SimpleDate from "../../../../../common/date/simple-date";
import ProfileService from "../../../../../../services/ProfileService";
import {join} from "../../../../../../utilities/url";

export default class ProfileBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: false,
            sessionExpiration: null
        };
    }

    componentDidMount() {
        ProfileService.expirationTimestamp.subscribe(this.update);
    }

    componentWillUnmount() {
        ProfileService.expirationTimestamp.unsubscribe(this.update);
    }

    update = () => this.forceUpdate();

    static defaultProps = {
        onNavigate: () => {}
    };

    render(props, state, context) {
        const spinner = <BackdropCover><Spinner/></BackdropCover>;
        const profile = ConfigService.userProfile();
        const hasProfile = Object.keys(profile || {}).length;
        const language = ConfigService.currentLanguage();

        const expiration = () => {
            return !ProfileService.expirationTimestamp() ? null : (
                <div className={style.profileInfoContainer}>
                    <div className={style.profileRow}>
                        <span className={style.profileRowField}><Text text={'profile.session_expiration'}/></span>
                        <span className={style.profileRowValue}><SimpleDate date={ProfileService.expirationTimestamp() * 1000}/></span>
                    </div>
                    {!ProfileService.sessionExpiring() ? null : (
                        <div class={style.profileRowAlert}>
                            <Text text={'profile.session_expiration_alert'} />
                        </div>
                    )}
                </div>
            )
        };

        const profileInfo = () =>
            <ScrollableSection>
                <div class={style.profileInfoContainer}>
                    <div class={style.profileRow}>
                        <span class={style.profileRowField}><Text text={'profile.attribute.username'}/></span>
                        <span class={style.profileRowValue}>{profile.username}</span>
                    </div>
                    <div class={style.profileRow}>
                        <span class={style.profileRowField}><Text text={'profile.attribute.email'}/></span>
                        <span class={style.profileRowValue}>{profile.email}</span>
                    </div>
                </div>
                <div class={style.profileInfoContainer} style={{paddingRight: ".25em"}}>
                    <div class={style.profileRow} style={{paddingRight: "0"}}>
                        <span class={style.profileRowField}><Text text={'language_dropdown_title'}/></span>
                        <span class={style.profileRowValue}>
                            <ToolbarButton type={'classic tertiary text'} onClick={this.openLanguageSelector}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <LanguageFlagIcon language={language} />
                                    <Text text={'language.' + language}/>
                                </div>
                            </ToolbarButton>
                        </span>
                    </div>
                </div>
                {expiration()}
                <div className={style.profileInfoContainer} style={{padding: '.5em'}}>
                    <ToolbarButton onClick={this.logout} type={'secondary text classic'}>
                        <LogoutIcon style={{marginRight: '.25em'}}/>
                        <Text text={'action.logout'}/>
                    </ToolbarButton>
                </div>
            </ScrollableSection>
        ;

        return (
            <VerticalUiContainer>
                {this.state.loading ? spinner : null}
                <Toolbar class={style.profileToolbar}>
                    <SectionContainer style={{justifyContent: 'flex-start', flex:2}}>
                        <div style={{margin: '0 .5em 0 .85em'}}><LetterIcon text={profile.username}/></div>
                        <ToolbarTitle>
                            <Text text={'profile.title'}/>
                        </ToolbarTitle>
                    </SectionContainer>
                    <SectionContainer style={{flex: "0 0 auto"}}>
                        <ToolbarButton onClick={this.navigateToProfile} type={'text tertiary classic'}>
                            <AccountEditIcon style={{marginRight: '.5em'}}/> <Text text={'profile.edit'}/>
                        </ToolbarButton>
                    </SectionContainer>
                </Toolbar>

                {hasProfile ? profileInfo() : ''}
            </VerticalUiContainer>
        );
    }

    openLanguageSelector = () => {
        this.props.onNavigate('language');
    };

    navigateToProfile = () => {
        this.base.dispatchEvent(createEvent('closeDropdown', {bubbles:true}));
        ConfigService.navigateFunction(join([ModuleInfoProvider.getModuleBackendUrl('extranet'), '/profile']));
    };

    logout = () => {
        this.base.dispatchEvent(createEvent('closeDropdown', {bubbles:true}));
        this.setState({loading: true});
        execute(ConfigService.logoutCallback, () => {
            const urlParts = [
                ModuleInfoProvider.getModuleBaseUrl('extranet', 'backend'),
                '/logout?redirectUrl=' + ConfigService.logoutRedirectUrl(),
            ];
            ConfigService.navigateFunction(join(urlParts));
            this.setState({loading: false});
        });
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/user/profile-box/index.js